/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import api from './api';

/** Fetch anonymous benchmark vs peers of the same specialty. */
export const getBenchmark = async () => (await api.get('/pro/benchmark')).data;

/** Fetch the list of awarded/unlocked badges for the current professional. */
export const getBadges = async () => (await api.get('/pro/badges')).data;

/** List all modulistica templates + categories. */
export const listModulistica = async () => (await api.get('/pro/modulistica')).data;

/** Fetch details + doctor prefill payload for a single module. */
export const getModulisticaDetail = async (docId) =>
  (await api.get(`/pro/modulistica/${docId}`)).data;
